import { render, staticRenderFns } from "./AssingOrgs.vue?vue&type=template&id=9584f6fe&scoped=true"
import script from "./AssingOrgs.vue?vue&type=script&lang=js"
export * from "./AssingOrgs.vue?vue&type=script&lang=js"
import style0 from "./AssingOrgs.vue?vue&type=style&index=0&id=9584f6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9584f6fe",
  null
  
)

export default component.exports